import {Icon, Typography} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

/** States the guest's read-only access once for the whole list, so no row repeats a role. */
export const GuestModeBanner: FC = () => {
  const {t} = useTranslation('guest');

  return (
    <div
      role="note"
      data-slot="guest-mode-banner"
      className="flex items-center gap-2.5 rounded-lg bg-background-secondary px-3.5 py-3"
    >
      <Icon name="view" aria-hidden className="size-5 shrink-0 text-brand-accent" />
      <Typography size="sm" color="secondary" className="whitespace-normal">
        <Typography as="span" size="sm" weight="semibold">
          {t('accounts.banner.title')}
        </Typography>{' '}
        {t('accounts.banner.description')}
      </Typography>
    </div>
  );
};
